<template>
  <ul class="rewards-comp">
    <li class="reward" v-for="(reward, idx) in rewards" :key="idx">
      <div class="avatar-wrapper" v-if="!hideAvatar">
        <slot name="avatar" :item="reward">
          <reward-trans-image v-bind="reward.transReward" :size="58" compact v-if="reward.transReward" />
          <lottery-reward-image
            :image="reward.icon"
            :icon="getLotteryTag(reward)"
            :size="46"
            v-else-if="getLotteryTag(reward)"
          />
          <img class="avatar" :src="reward.icon" alt="" v-else />
        </slot>
      </div>

      <div class="info">
        <slot name="name" :item="reward">
          <div class="name">{{ reward.name }}</div>
        </slot>

        <div class="time">{{ reward.time }}</div>
      </div>

      <kd-button
        :type="reward.btnType"
        size="mini"
        :disabled="reward.disabled"
        round
        @click="jumpToTarget(reward)"
        v-if="!hideDisabledBtn || !reward.disabled"
      >
        {{ reward.btnLabel }}
      </kd-button>
    </li>

    <kd-no-data text="—  没有更多了 —" v-if="rewards.length" />
    <kd-no-data :text="emptyText" v-else />
  </ul>
</template>

<script setup lang="ts">
import { IReward } from '../models/reward'
import { KdButton, KdNoData } from 'kuaidong-ui'
import RewardTransImage from './RewardTransImage.vue'
import LotteryRewardImage from './LotteryRewardImage.vue'
import { lotteryRewardListDataKey } from '../service/lotteryService'

withDefaults(
  defineProps<{
    rewards: IReward[]
    emptyText?: string
    hideAvatar?: boolean
    hideDisabledBtn?: boolean
  }>(),
  {
    emptyText: '— 当前还没有奖品 —',
  }
)

const emits = defineEmits(['jump-to-target'])

function getLotteryTag(_reward: IReward) {
  return _reward.data?.[lotteryRewardListDataKey] || ''
}

async function jumpToTarget(reward: IReward) {
  await reward.action?.()
  emits('jump-to-target', reward)
}
</script>

<style lang="less">
.rewards-comp {
  padding: 16px;
  min-height: 100vh;
  text-align: left;
  background: #fff;
  box-sizing: border-box;

  > .reward {
    display: flex;
    align-items: center;

    + .reward {
      margin: 12px 0 0 0;
    }

    + .kd-no-data {
      margin: 16px 0 0 0;
    }

    > .avatar-wrapper {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 12px 0 0;
      width: 58px;
      height: 58px;
      background: #fff3e4;
      border-radius: 16px;
      overflow: hidden;

      > .avatar {
        width: 46px;
        height: 46px;
        object-fit: scale-down;
      }

      > .reward-trans-image {
        display: block;
      }

      > .lottery-reward-image-comp {
        display: block;
      }
    }

    > .info {
      margin: 0 auto 0 0;

      > .name {
        line-height: 24px;
        font-size: 16px;
        font-weight: 500;
        color: #000;
      }

      > .time {
        margin: 4px 0 0 0;
        line-height: 18px;
        font-size: 12px;
        color: #939599;
      }
    }

    > .kd-button {
      flex: none;
      margin: 0 0 0 12px;
      padding: 0;
      width: 72px;
      height: 32px;
      border-radius: 60px;

      &.kd-button__type--function {
        color: #939599;
        background: #f4f5f7;
      }
    }
  }

  > .kd-no-data {
    margin: 0;
  }
}
</style>
